module.exports = __webpack_public_path__ + "39332fb1d9ea593475bbdd4860fdcf0b.svg";